import * as React from 'react';

interface IEntityPaneHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  trailingContent?: React.ReactNode;
  avatar?: React.ReactNode;
}

const EntityPaneHeader = ({ title, subtitle, trailingContent, avatar }: IEntityPaneHeaderProps) => {
  return (
    <div className="flex items-center justify-between px-4 pb-4 pt-8 lg:px-8 lg:pb-8 lg:pt-12">
      <div className="flex min-w-0 items-center gap-3">
        {avatar && <div className="flex items-center">{avatar}</div>}
        <div className="flex min-w-0 flex-col">
          <div className="text-primary text-display-sm truncate font-medium">{title}</div>
          {subtitle && <div className="text-tertiary truncate text-sm font-medium">{subtitle}</div>}
        </div>
      </div>
      {trailingContent && <div className="text-secondary ml-1 flex shrink-0 pr-3 text-sm">{trailingContent}</div>}
    </div>
  );
};

export default EntityPaneHeader;
